import { render, staticRenderFns } from "./PageStructurePageListItem.vue?vue&type=template&id=b13f6f82&"
import script from "./PageStructurePageListItem.vue?vue&type=script&lang=ts&"
export * from "./PageStructurePageListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructurePageListItem.vue?vue&type=style&index=0&id=b13f6f82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports